String.prototype.colorRgb = function (op) {
  let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  let sColor = this.toLowerCase();
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      let sColorNew = "#";
      for (let i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
      }
      sColor = sColorNew;
    }
    //处理六位的颜色值
    let sColorChange = [];
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt(`0x${ sColor.slice(i, i + 2)}`));
    }
    if (op) {
      return `rgba(${ sColorChange.join(",") },${ op })`;
    } else {
      return `rgba(${ sColorChange.join(",") })`;
    }
  } else {
    return sColor;
  }
};
DT.Layer = function (canvasLayer, id) {
  this.type = 'layer';
  this.markers = new DT.HashMap();
  this.id = id;
  this.canvasLayer = canvasLayer;
  this.setCanvasOptions = function () {
    if (!this.canvasLayer) {
      return;
    }
    this.canvasLayer.setOptions(this.createCanvasLayerOptions(), this.id);
  };
  this.createCanvasLayerOptions = function () {
    return {
      type: 'Marker',
      icon: {},
      parser: function (data) {
        let _data = {};
        _data.id = data.id;
        _data.x = data.x;
        _data.y = data.y;
        _data.icon = data.icon;
        _data.label = data.label;
        return _data;
      },
      enableMouseOver: 0,
      event: {
        click: function (data, e) {
          let feature = data;
          $(document).trigger('select_feature', feature);
        }
      }
    };
  };
  this.getFeatures = function () {
    return this.markers.values();
  };
  this.clearHashMap = function () {
    this.markers.clear();
  };
  this.getFeature = function (id) {
    return this.markers.get(id);
  };
  this.setData = function (markerList) {
    if (!this.canvasLayer) {
      return;
    }
    let markers = [];
    for (let i = 0; i < markerList.length; i++) {
      let marker = markerList[i];
      if (marker.x && marker.y) {
        markers.push(marker);
      }
    }
    this.canvasLayer.setData(markers, this.id);
  };
  this.updateData = function (markerList) {
    if (!this.canvasLayer) {
      return;
    }
    let markers = [];
    for (let i = 0; i < markerList.length; i++) {
      let marker = markerList[i];
      if (marker.x && marker.y) {
        markers.push(marker);
      }
    }
    this.canvasLayer.updateData(markers, this.id);
  };
};

const colors = ["5D4A43", "12BBD2", "1DF3BE", "18FFFF", "658EB7", "3236B7", "0467B7", "D59E87", "6FB1B6", "004325", "D0021B", "606E6C", "D500F9", "8832FF", "651FFE", "9010A4", "FF675C", "AE99DB", "5F4A9A", "5D6670", "9BB6B9", "6A9BC7", "DD55B3", "EEB3D4", "2F6D81", "886768", "5CBB16", "9E9E24", "548B2D", "B3FE59"];
export const createLayer = function (canvasLayer, id) {
  return new DT.Layer(canvasLayer, id);
};

export const getColors = function (num) {
  let min = 0;
  let max = colors.length;
  if (num < 0 || num > colors.length) {
    return 'num错误';
  }
  let colorArray = [];
  for (let i = 0; i < num; i++) {
    let index = Math.floor(Math.random() * (max - min + 1 ) + 1) - 2;
    if (index < 0) {
      index = 0;
    }
    let color = colors[index];
    if (colorArray.indexOf(color) >= 0) {
      i--;
    } else {
      colorArray.push(color);
    }
  }
  return colorArray;
};





// WEBPACK FOOTER //
// ./src/assets/javascript/map_utils.js